export default __webpack_public_path__ + "static/media/logo-text-white.705744f9.png";